import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PlatformsService {

  isIOs(): boolean {
    const userAgent = window.navigator.userAgent || navigator.vendor;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);
     const isIPadOS =navigator.userAgent.includes('Mac') && 'ontouchend' in document;
    return isIOS || isIPadOS;
  }

  // True when running inside the La Colonial native webview (iOS or
  // Android). The Flutter app sets this flag before the page boots so
  // the guard/interceptor know to use the injected hash instead of MSAL.
  isEmbeddedApp(): boolean {
    try {
      return localStorage.getItem('embeddedColonialApp') === '1';
    } catch {
      return false;
    }
  }

}
